export const NAME = 'analytics' as const;

export const STATSIG_LOGGING_BUFFER_MAX_SIZE = 2;
export const STATSIG_LOGGING_INTERVAL_MS = 1000;

export const MAINTAIN_ACTIVE_SESSION_INTERVAL_SECONDS = 60;
export const IDLE_TIMEOUT_SECONDS = 120;
